import { ICompany } from '@app/src/components/user-management/model/Company';
import { UserGroup } from '@app/src/components/user-management/model/UserGroup';
import { INamedItem } from '@app/src/common/model/ListModel';

export interface IUser {
  id: string;
  email: string;
  phoneNumber?: string;
  firstName: string;
  lastName: string;
  description: string;
  externalId?: string;
  external: boolean;
  language: string;
  companyId: string;
  company: ICompany;
  roles: IRole[];
  groupsRoles: IRole[];
  locationRoles: IUserLocationRolesDetails[] | null;
  groupsLocationRoles: IUserLocationRolesDetails[] | null;
  password?: string;
  username?: string;
}

export interface IUserInList {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  companyId: string;
  companyName: string;
  roles: IRole[];
  locked: boolean;
  external: boolean;
  description: string;
  groups: UserGroup[];
  lastUsedAt: string | null;
  locationRoles: IUserLocationRolesDetails[] | null;
}

export interface IUserForUpdate {
  id?: string;
  email: string;
  phone?: string;
  firstName: string;
  lastName: string;
  description: string;
  externalId?: string;
  language: string;
  roles: string[];
  locationRoles: IUserLocationRoles[] | null;
  password?: string;
  companyId?: string;
  sendInvitationEmail?: boolean;
}

export const ExternalIdValidationCode = 'UM0014';
export const EmailUniqueCode = 'UM0003';
export const LastAdminCode = 'UM0005';
export const UserNameUniqueCode = 'UM0029';
export const LocationAssignmentInUseCode = 'UM0035';

export interface IDeviceGroupManager {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  isDeleted: boolean;
}

export interface IPermission {
  id: string;
  key: string;
  name: string;
  type?: PermissionType; // fe only
}

export enum PermissionType {
  Company = 'c',
  Own = 'o',
  Restricted = 'r',
  UI = 'u',
  Tenant = 't'
}

export interface IRoleListItem {
  id: string;
  key: string;
  name: string;
  description: string;
  abbreviation: string;
  roleType: UserRoleType;
  allowLocationAssignment: boolean;
  includeDeletedRole?: boolean;
  deletedDate?: string;
}

export interface IRole extends IRoleListItem {
  roles?: IRole[];
  permissions?: IPermission[];
}

export interface IRoleNamedItem extends INamedItem {
  roleType: UserRoleType;
  allowLocationAssignment: boolean;
}

export interface IRoleFormObject {
  key: string;
  name: string;
  description: string;
  abbreviation: string;
  allowLocationAssignment: boolean;
}

export interface IRoleForCreate {
  key?: string;
  name: string;
  description: string;
  abbreviation: string;
  roleType: UserRoleType;
  allowLocationAssignment: boolean;
  roles?: string[];
  permissions?: string[] | null;
}

export interface IRoleForUpdating {
  roleId: string;
  name: string;
  description: string;
  abbreviation: string;
  allowLocationAssignment: boolean;
  roles: string[] | null;
  permissions: string[] | null;
}

export enum UserRoleType {
  BaseOrigin = 1,
  BaseAll = 2,
  BaseCompany = 3,
  BaseOwn = 4,
  Default = 5,
  Custom = 6,
  Hidden = 7
}

export interface IApiKey {
  id: string;
  apiKey: string;
}

export interface IUserDocument {
  id: string;
  fileId: string;
  name: string;
  downloadUrl: string;
  signDateTime: string;
}

export interface IUserLocationRoles {
  locationId: string;
  roles: string[];
}

export interface IUserLocationRolesDetails {
  locationId: string;
  roles: IRole[];
}
